import { ChangeDetectorRef, ElementRef, forwardRef, Injector, Renderer2 } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { BasicInput } from '../basic-input/basic-input';
import * as i0 from "@angular/core";
import * as i1 from "../input-ref/input-ref.directive";
import * as i2 from "../input-ref/form-control-name";
import * as i3 from "@angular/forms";
export const INPUT_TEXT_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => UiInputTextComponent),
  multi: true
};
// @Directive({
//     selector: '[uiInputText]',
// 	host: {
//         '[class.p-input-text]': 'true',
//         '[class.p-component]': 'true',
//         '[class.p-filled]': 'filled'
//     }
// })
// export class InputText extends InputTextBase {}
// custom component using primeNG styles
export let UiInputTextComponent = /*#__PURE__*/(() => {
  class UiInputTextComponent extends BasicInput {
    constructor(cd, el, renderer, injector) {
      super(cd);
      this.cd = cd;
      this.el = el;
      this.renderer = renderer;
      this.injector = injector;
      this.type = 'text';
      this.placeholder = '';
      this.autocomplete = true;
      this.width = null;
      this.castTo = null;
    }
    ngOnInit() {
      if (this.width) {
        const width = typeof this.width === 'number' ? this.width + 'px' : this.width;
        this.renderer.setStyle(this.el.nativeElement, 'width', width);
      }
    }
    writeValue(value) {
      // based on castTo, the incoming value may be something different than a string!
      if (this.castTo && typeof value === 'number') this.value = '' + value;else this.value = value;
      this.cd.markForCheck();
    }
    updateValue(val) {
      this.value = val;
      if (this.castTo) {
        if (this.castTo === 'int') {
          val = parseInt(val, 10);
        } else if (this.castTo === 'float') {
          val = parseFloat(val);
        }
      }
      this.onModelChange(val);
    }
    static {
      this.ɵfac = function UiInputTextComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiInputTextComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.Injector));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiInputTextComponent,
        selectors: [["ui-input-text"]],
        inputs: {
          type: "type",
          placeholder: "placeholder",
          autocomplete: "autocomplete",
          width: "width",
          castTo: "castTo"
        },
        features: [i0.ɵɵProvidersFeature([INPUT_TEXT_VALUE_ACCESSOR]), i0.ɵɵHostDirectivesFeature([i1.InputRefDirective, {
          directive: i2.FormControlNameStandalone,
          inputs: ["formControlName", "formControlNameStandalone"]
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 6,
        consts: [["ele", ""], ["e2e-input-text", "", 1, "p-input-text", "p-component", "p-filled", 3, "focus", "blur", "ngModelChange", "type", "placeholder", "disabled", "readonly", "autocomplete", "ngModel"]],
        template: function UiInputTextComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "input", 1, 0);
            i0.ɵɵlistener("focus", function UiInputTextComponent_Template_input_focus_0_listener($event) {
              return ctx.focusInput($event);
            })("blur", function UiInputTextComponent_Template_input_blur_0_listener($event) {
              return ctx.blurInput($event);
            })("ngModelChange", function UiInputTextComponent_Template_input_ngModelChange_0_listener($event) {
              return ctx.updateValue($event);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("type", ctx.type)("placeholder", ctx.placeholder)("disabled", ctx.disabled)("readonly", ctx.readonly)("autocomplete", !ctx.autocomplete ? "new-password" : undefined)("ngModel", ctx.value);
          }
        },
        dependencies: [FormsModule, i3.DefaultValueAccessor, i3.NgControlStatus, i3.NgModel, ReactiveFormsModule],
        styles: ["ui-input-text{--borderLeftRadius:var(--inputBorderRadius);--borderRightRadius:var(--inputBorderRadius);display:block}ui-input-text input{width:100%}ui-input-text .p-input-text{height:var(--inputHeight)}.ui-form-theme-invisible ui-input-text .p-input-text{background:transparent;border-color:transparent}.ui-form-theme-invisible ui-input-text .p-input-text:hover,.ui-form-theme-invisible ui-input-text .p-input-text.ng-touched.ng-invalid{border:1px solid #a6a6a6;border-color:var(--inputBorderColor)}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return UiInputTextComponent;
})();